import React from 'react';

const styles = {
    shell: {
        position: 'relative',
    },
    content: {
        transition: 'filter 0.5s ease, opacity 0.5s ease',
    },
    contentLocked: {
        filter: 'blur(12px)',
        opacity: 0.6,
        pointerEvents: 'none',
        userSelect: 'none',
    },
    overlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        zIndex: 2,
    },
    panel: {
        width: '100%',
        maxWidth: '560px',
        background: 'linear-gradient(135deg, rgba(15,23,42,0.95), rgba(30,41,59,0.95))',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: '24px',
        padding: '2rem',
        textAlign: 'center',
        backdropFilter: 'blur(14px)',
        boxShadow: '0 20px 60px rgba(15,23,42,0.45)',
    },
    title: {
        margin: '0 0 0.75rem 0',
        color: '#f8fafc',
        fontSize: '1.5rem',
        fontWeight: 800,
    },
    description: {
        margin: '0 0 1.5rem 0',
        color: '#cbd5e1',
        fontSize: '1rem',
        lineHeight: 1.7,
    },
    button: {
        background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
        color: '#fff',
        border: 'none',
        padding: '1rem 2rem',
        borderRadius: '999px',
        fontSize: '1rem',
        fontWeight: 700,
        cursor: 'pointer',
        boxShadow: '0 12px 28px rgba(59,130,246,0.35)',
    },
    footer: {
        marginTop: '2rem',
    },
};

const PremiumInlineGate = ({
    locked,
    title,
    description,
    primaryActionLabel,
    onPrimaryAction,
    children,
    footer = null,
}) => {
    return (
        <div style={styles.shell}>
            <div style={{ ...styles.content, ...(locked ? styles.contentLocked : null) }}>
                {children}
            </div>

            {locked ? (
                <div style={styles.overlay}>
                    <div style={styles.panel}>
                        {title ? <h3 style={styles.title}>{title}</h3> : null}
                        {description ? <p style={styles.description}>{description}</p> : null}
                        {primaryActionLabel ? (
                            <button type="button" onClick={onPrimaryAction} style={styles.button}>
                                {primaryActionLabel}
                            </button>
                        ) : null}
                    </div>
                </div>
            ) : null}

            {!locked && footer ? <div style={styles.footer}>{footer}</div> : null}
        </div>
    );
};

export default PremiumInlineGate;
